import { getBusySeats } from 'controller/event/getBusySeats'
import { getCategories } from 'controller/event/getCategories'
import { getData } from 'controller/event/getData'
import { getFees } from 'controller/event/getFees'
import { getGoods } from 'controller/event/getGoods'
import { getSectionsEnabled } from 'controller/event/getSectionsEnabled'
import { getTypeTickets } from 'controller/event/getTypeTickets'

import { getBulkData } from './getBulkData'
import { getMetadata } from './getMetadata'

export const EventController = {
  getBusySeats,
  getCategories,
  getFees,
  getGoods,
  getSectionsEnabled,
  getTypeTickets,
  getMetadata,
  getData,
  getBulkData,
}
